import {
  LANGUAGE_ATTRIBUTE_TYPE,
  isLanguageAttributeType,
  type SelectedProductAttribute,
  type TariffGroupAttributeType,
} from '@src/domains/products/features/product-booking/types/attribute';

export const getSelectedAttributeValue = (
  attributes: SelectedProductAttribute[],
  type: TariffGroupAttributeType,
): string | null => attributes.find((attribute) => attribute.type === type)?.value ?? null;

export const getNonLanguageSelectedAttributes = (attributes: SelectedProductAttribute[]): SelectedProductAttribute[] =>
  attributes.filter((attribute) => !isLanguageAttributeType(attribute.type));

export const upsertSelectedAttributes = (
  current: SelectedProductAttribute[],
  incoming: SelectedProductAttribute[],
): SelectedProductAttribute[] => {
  const merged: SelectedProductAttribute[] = current.map((attribute) => {
    const replacement = incoming.find((candidate) => candidate.type === attribute.type);

    return replacement ? { type: attribute.type, value: replacement.value } : attribute;
  });

  for (const attribute of incoming) {
    if (!merged.some((existing) => existing.type === attribute.type)) {
      merged.push({ type: attribute.type, value: attribute.value });
    }
  }

  return merged;
};

export { LANGUAGE_ATTRIBUTE_TYPE };
